exports = module.exports = require("/Volumes/Work/ITCase/baikal430/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".Footer{display:inline-block}.Footer__brands{margin:2rem 0}.Footer__brands a{margin-right:2rem}.Footer__copyright{font-size:1.2rem;display:block;color:#b8b8b8}.Footer__copyright *{display:inline-block;vertical-align:bottom}.Footer__copyright img{margin-bottom:-1px}.Footer__copyright span{margin-right:5px}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/stylus-loader!./src/components/Footer/Footer.styl
// module id = 211
// module chunks = 0